import { Icon } from "./icon"

type Size = "font" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"

export default function SocialIcons({ size = 'font' }: { size?: Size }) {
  return (
    <>
      <a href="https://www.instagram.com/rohnamusic" target="_blank" rel="noopener noreferrer" className="hover:scale-105 hover:text-white" aria-label="Instagram (opens in new tab)">
        <Icon name="instagram" size={size} title="Instagram"></Icon>
      </a>

      <a href="https://www.tiktok.com/@rohnamusic" target="_blank" rel="noopener noreferrer" className="hover:scale-105 hover:text-white" aria-label="TikTok (opens in new tab)">
        <Icon name="tiktok" size={size} title="TikTok"></Icon>
      </a>

      <a href="https://open.spotify.com/artist/7yH9wdVRj7Po5vpa19yNC2?si=HIud4zziRW2rtxDE0Wz2BA" target="_blank" rel="noopener noreferrer" className="hover:scale-105 hover:text-white" aria-label="Spotify (opens in new tab)">
        <Icon name="spotify" size={size} title="Spotify"></Icon>
      </a>

      <a href="https://music.apple.com/us/artist/rohna/1469839464" target="_blank" rel="noopener noreferrer" className="hover:scale-105 hover:text-white" aria-label="Apple Music (opens in new tab)">
        <Icon name="apple" size={size} title="Apple Music"></Icon>
      </a>

      <a href="https://www.youtube.com/@rohnamusic" target="_blank" rel="noopener noreferrer" className="hover:scale-105 hover:text-white" aria-label="YouTube (opens in new tab)">
        <Icon name="youtube" size={size} title="Youtube"></Icon>
      </a>

      <a href="https://bnds.us/jih8ni" target="_blank" rel="noopener noreferrer" className="hover:scale-105 hover:text-white" aria-label="Bandsintown (opens in new tab)">
        <Icon name="bandsintown" size={size} title="Bands In Town"></Icon>
      </a>
    </>
  )
}